<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="header-title">Select organization </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal row">
    <div class="col-md-12 mt-4">
      <div class="services-form dataTables_filter mb-4" id="tblProjects_filter">
        <input
          type="text"
          class="form-control input-sm"
          placeholder="Search..."
          aria-controls="tblProjects"
          [formControl]="searchControl"
          (input)="callFilter($event)"
          #searchFilter
        />
        <label class="search-margin">Search...</label>
        <span class="searchIcon" *ngIf="!isShowClearIcon">
          <i class="fa fa-search icon"></i>
        </span>
        <span *ngIf="isShowClearIcon" (click)="clearSearchBox()" class="searchIcon">
          <i class="fa fa-close icon"></i>
        </span>
      </div>
    </div>
    <ng-container *ngIf="selectedOrganization.length > 0">
      <div *ngFor="let organization of selectedOrganization" class="organizationModel">
        <div class="organizationList">
          <div>
            <input
              class="radioColorOrganization"
              id="enum_answer_{{ organization.name }}"
              type="radio"
              name="enums"
              [value]="organization"
              [(ngModel)]="radioSelected"
            />
          </div>
          <span class="organization-text"> {{ organization.name }}</span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="no-match-found" *ngIf="selectedOrganization.length === 0">No match found</div>

  <div class="modal-footer align-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="currentOrganization?.id == radioSelected?.id"
      (click)="save(radioSelected.id)"
    >
      Save
    </button>
  </div>
</div>
